import { Blinker } from '../../../Common/Blinker'
import { ScreenOptionsManager } from '../../ScreenOptionsManager'

export const LinksScreen = () => {
    return (
        <div className="flex flex-wrap justify-center items-center p-y-2 gap-x-2 gap-y-2 h-full">
            <div className="w-[74%] justify-center">
                <ScreenOptionsManager options={[ 'WowBoi X', 'Fromp X', 'Image Assets']} fullWidth/>
                {/* <p className='interactions-text text-xs'> 
                    <Blinker interval={550}>
                        <span>
                            {"<"} Z 
                        </span>
                    </Blinker>
                </p> */}
            </div>
        </div>
    )
}
